/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductAnnouncement
 */
export interface ProductAnnouncement {
    /**
     * 
     * @type {string}
     * @memberof ProductAnnouncement
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof ProductAnnouncement
     */
    publishedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ProductAnnouncement
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAnnouncement
     */
    summary: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAnnouncement
     */
    category: ProductAnnouncementCategoryEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductAnnouncement
     */
    body: Array<string>;
    /**
     * Required hero image or animated GIF shown in the announcement detail.
     * @type {string}
     * @memberof ProductAnnouncement
     */
    mediaUrl: string;
    /**
     * Accessible description of the announcement hero media.
     * @type {string}
     * @memberof ProductAnnouncement
     */
    mediaAltText: string;
    /**
     * PostHog feature flag that must be enabled before the announcement is shown.
     * @type {string}
     * @memberof ProductAnnouncement
     */
    featureFlag?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAnnouncement
     */
    ctaLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAnnouncement
     */
    ctaHref?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductAnnouncement
     */
    isRead: boolean;
}


/**
 * @export
 */
export const ProductAnnouncementCategoryEnum = {
    New: 'new',
    Improved: 'improved',
    Fixed: 'fixed'
} as const;
export type ProductAnnouncementCategoryEnum = typeof ProductAnnouncementCategoryEnum[keyof typeof ProductAnnouncementCategoryEnum];


/**
 * Check if a given object implements the ProductAnnouncement interface.
 */
export function instanceOfProductAnnouncement(value: object): value is ProductAnnouncement {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('publishedAt' in value) || value['publishedAt'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('mediaUrl' in value) || value['mediaUrl'] === undefined) return false;
    if (!('mediaAltText' in value) || value['mediaAltText'] === undefined) return false;
    if (!('isRead' in value) || value['isRead'] === undefined) return false;
    return true;
}

export function ProductAnnouncementFromJSON(json: any): ProductAnnouncement {
    return ProductAnnouncementFromJSONTyped(json, false);
}

export function ProductAnnouncementFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductAnnouncement {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'publishedAt': (new Date(json['published_at'])),
        'title': json['title'],
        'summary': json['summary'],
        'category': json['category'],
        'body': json['body'],
        'mediaUrl': json['media_url'],
        'mediaAltText': json['media_alt_text'],
        'featureFlag': json['feature_flag'] == null ? undefined : json['feature_flag'],
        'ctaLabel': json['cta_label'] == null ? undefined : json['cta_label'],
        'ctaHref': json['cta_href'] == null ? undefined : json['cta_href'],
        'isRead': json['is_read'],
    };
}

export function ProductAnnouncementToJSON(json: any): ProductAnnouncement {
    return ProductAnnouncementToJSONTyped(json, false);
}

export function ProductAnnouncementToJSONTyped(value?: ProductAnnouncement | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'published_at': value['publishedAt'].toISOString(),
        'title': value['title'],
        'summary': value['summary'],
        'category': value['category'],
        'body': value['body'],
        'media_url': value['mediaUrl'],
        'media_alt_text': value['mediaAltText'],
        'feature_flag': value['featureFlag'],
        'cta_label': value['ctaLabel'],
        'cta_href': value['ctaHref'],
        'is_read': value['isRead'],
    };
}

